import {makeObservable} from 'mobx';

import {BaseModel} from '../../Base/Base.model';

const ModelName = 'UserAdditionalDataModel';

export class UserAdditionalDataQuestion {
  /** The API stores every answer as a list, even when it holds one value. */
  answer: string | string[] = '';
  question = '';

  constructor(props: UserAdditionalDataQuestion.Props) {
    this.answer = props.answer;
    this.question = props.question;
  }
}

namespace UserAdditionalDataQuestion {
  export type Props = {answer: string | string[]; question: string};
}

export class UserAdditionalDataModel extends BaseModel {
  questions: UserAdditionalDataQuestion[] = [];

  constructor(props: UserAdditionalDataModel.Props) {
    super({id: ''});
    Object.assign(this, props);
    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<
        UserAdditionalDataModel,
        UserAdditionalDataModel.Props
      >(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace UserAdditionalDataModel {
  export type Props = BaseModel.ModelToProps<UserAdditionalDataModel, 'id'>;
}
